// types should always be imperative verbs
export const FLAG_GETTING_REGISTERED_BUSES = 'FLAG_GETTING_REGISTERED_BUSES';
export const GET_REGISTERED_BUSES = 'GET_REGISTERED_BUSES';
export const CLEAR_REGISTERED_BUSES = 'CLEAR_REGISTERED_BUSES';
export const FLAG_REGISTERED_BUS_ACTIVITY = 'FLAG_REGISTERED_BUS_ACTIVITY';
export const GET_REGISTERED_BUS = 'GET_REGISTERED_BUS';
export const CLEAR_REGISTERED_BUS = 'CLEAR_REGISTERED_BUS';
